/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scim_Setup_Okta_Step4Inputs */



/**
* | output |
* | --- |
* | "Set authentication mode to HTTP Header and enter the Bearer Token" |
*
* @param {Scim_Setup_Okta_Step4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const scim_setup_okta_step4 = /** @type {((inputs?: Scim_Setup_Okta_Step4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scim_Setup_Okta_Step4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Setzen Sie den Authentifizierungsmodus auf HTTP-Header und geben Sie das Bearer-Token ein")
	return /** @type {LocalizedString} */ ("Set authentication mode to HTTP Header and enter the Bearer Token")
});